<template>
  <div class="webglContainer" style="overflow:hidden">
    <div id="webgl" ref="webgl"></div>
    <div class="btn" @click="tweenCamera()">旋转</div>
    <div class="loading" v-if="!hasLoaded">
          <div class="spinner">
              <div class="spinner-container container1">
                  <div class="circle1"></div>
                  <div class="circle2"></div>
                  <div class="circle3"></div>
                  <div class="circle4"></div>
              </div>
              <div class="spinner-container container2">
                  <div class="circle1"></div>
                  <div class="circle2"></div>
                  <div class="circle3"></div>
                  <div class="circle4"></div>
              </div>
              <div class="spinner-container container3">
                  <div class="circle1"></div>
                  <div class="circle2"></div>
                  <div class="circle3"></div>
                  <div class="circle4"></div>
              </div>
          </div>
        </div>
  </div>
</template>
<style>
  .webglContainer{
    width: 100%;
    height: 100%;
    position: relative;
    background-image: linear-gradient(#000000 ,#ababab);
  }
  #webgl{
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .btn{
    width: 100px;
    height: 30px;
    position: absolute;
    background-color: #000000;
    text-align: center;
    line-height: 30px;
    color: white;
    right: 0;
    bottom: 0;
  }
  .loading{
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 99;
            left: 0;
            top: 0;
            display: block;
        }
        .spinner {
            width: 120px;
            height: 120px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left:-60px;
            margin-top: -60px;
        }

        .spinner .container1 > div,.spinner .container2 > div,.spinner .container3 > div {
            width: 24px;
            height: 24px;
            background-color: #fff;

            border-radius: 100%;
            position: absolute;
            -webkit-animation: bouncedelay 1.2s infinite ease-in-out;
            animation: bouncedelay 1.2s infinite ease-in-out;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
        }

        .spinner .spinner-container {
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .spinner .container2 {
            -webkit-transform: rotateZ(45deg);
            transform: rotateZ(45deg);
        }

        .spinner .container3 {
            -webkit-transform: rotateZ(90deg);
            transform: rotateZ(90deg);
        }

        .spinner .circle1 { top: 0; left: 0; }
        .spinner .circle2 { top: 0; right: 0; }
        .spinner .circle3 { right: 0; bottom: 0; }
        .spinner .circle4 { left: 0; bottom: 0; }

        .spinner .container2 .circle1 {
            -webkit-animation-delay: -1.1s;
            animation-delay: -1.1s;
        }

        .spinner .container3 .circle1 {
            -webkit-animation-delay: -1.0s;
            animation-delay: -1.0s;
        }

        .spinner .container1 .circle2 {
            -webkit-animation-delay: -0.9s;
            animation-delay: -0.9s;
        }

        .spinner .container2 .circle2 {
            -webkit-animation-delay: -0.8s;
            animation-delay: -0.8s;
        }

        .spinner .container3 .circle2 {
            -webkit-animation-delay: -0.7s;
            animation-delay: -0.7s;
        }

        .spinner .container1 .circle3 {
            -webkit-animation-delay: -0.6s;
            animation-delay: -0.6s;
        }

        .spinner .container2 .circle3 {
            -webkit-animation-delay: -0.5s;
            animation-delay: -0.5s;
        }

        .spinner .container3 .circle3 {
            -webkit-animation-delay: -0.4s;
            animation-delay: -0.4s;
        }

        .spinner .container1 .circle4 {
            -webkit-animation-delay: -0.3s;
            animation-delay: -0.3s;
        }

        .spinner .container2 .circle4 {
            -webkit-animation-delay: -0.2s;
            animation-delay: -0.2s;
        }

        .spinner .container3 .circle4 {
            -webkit-animation-delay: -0.1s;
            animation-delay: -0.1s;
        }

        @-webkit-keyframes bouncedelay {
            0%, 80%, 100% { -webkit-transform: scale(0.0) }
            40% { -webkit-transform: scale(1.0) }
        }

        @keyframes bouncedelay {
            0%, 80%, 100% {
                transform: scale(0.0);
                -webkit-transform: scale(0.0);
            } 40% {
                  transform: scale(1.0);
                  -webkit-transform: scale(1.0);
              }
        }
</style>
<script>
import https from "@/https.js";
// import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
// import "swiper/css/swiper.css";
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import zcfCommon from '../../public/com/zcf_common'
let vm = null
export default {
  components: {
    // Swiper,
    // SwiperSlide,
  },
  data() {
    return {
      modelID: '',
      hasLoaded: false,
      modelInfo:'',
    };
  },
  created() {
    this.modelID = this.$route.query.itemID|| '0783e09e-2cfb-4c52-999a-19ec8a4b3f05'
    vm = this
  },
  mounted() {
    this.clock = new THREE.Clock()
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.tan = null
    this.tang = null
    this.rou = null
    this.meshBei = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.lightGroup = new THREE.Group()
    this.lightHelpGroup = new THREE.Group()
    this.textrueLoader = new THREE.TextureLoader()
    this.pmremGenerator = null
    this.composerScene = null
    this.composer = null
    this.effect1 = null
    this.shader = {}
    this.engine = null
    this.engines = []
    https.fetchGet('/GetSceneInfo', {
        id: this.modelID
      }).then(
        res => {
          if(res.status === 200) {
            console.log(res)
            this.modelInfo = res.data
            
            this.init()
          }
        }
      );
  },
  methods: {
    tweenCamera(){
      new TWEEN.Tween(this.camera.position)
        .to({ x: 50,y:0,z:0 }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(function () {
          vm.camera.updateProjectionMatrix()
        }).onComplete(function () {
          console.log(vm.camera.position)
        })
    },
    // 场景初始
    init () {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.scene.add(this.lightGroup)
      let modelLoader
      this.camera = new THREE.PerspectiveCamera(
        60,
        this.containerW / this.containerH,
        0.01,
        9999
      )
      this.camera.position.set(50, 0, 0)
      this.camera.name = 'camera'
      this.scene.add(this.camera)

      let ambientLight = new THREE.AmbientLight(0xaaaaaa)
      this.scene.add(ambientLight)

      let directionalLight = new THREE.DirectionalLight(0xffffff, 1.2)
      directionalLight.position.set(-50, 100, -50)
      this.scene.add(directionalLight)
      // directionalLight.castShadow = true
      // directionalLight.shadow.camera.top = 100
      // directionalLight.shadow.camera.bottom = -100
      // directionalLight.shadow.camera.left = -100
      // directionalLight.shadow.camera.right = 100
      // directionalLight.shadow.camera.near = 1
      // directionalLight.shadow.camera.far = 5000
      // directionalLight.shadow.mapSize.width = 1024 * 2 // default
      // directionalLight.shadow.mapSize.height = 1024 * 2 // default

      let directionalLight01 = new THREE.DirectionalLight(0xffffff, 0.6)
      directionalLight01.position.set(100, 0, 100)
      this.scene.add(directionalLight01)

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.renderer.outputEncoding = THREE.GammaEncoding
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.containerW, this.containerH)
      // this.renderer.shadowMap.enabled = true
      // this.renderer.shadowMap.type = THREE.PCFSoftShadowMap

      this.container.appendChild(this.renderer.domElement)

      //controls
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      this.controls.enableDamping = true
      this.controls.dampingFactor = 0.1

      let textrueLoader = new THREE.TextureLoader()
      let envMap
      this.pmremGenerator = new THREE.PMREMGenerator(this.renderer)
      this.pmremGenerator.compileEquirectangularShader()
      textrueLoader.load('env/EnvMap01.jpg', (texture) => {
        texture.encoding = THREE.sRGBEncoding

        let pngCubeRenderTarget = this.pmremGenerator.fromEquirectangular(texture)

        envMap = pngCubeRenderTarget.texture

        texture.dispose()
      })

      modelLoader = new GLTFLoader()
      var dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('com/draco/gltf/')
      modelLoader.setDRACOLoader(dracoLoader)
      modelLoader.setPath('https://model001.z2ww.com/'+this.modelInfo.path+'/')
      modelLoader.load('model.gltf', gltf => {
        this.mesh = gltf.scene
        this.scene.add(this.mesh)
        this.mesh.traverse((child) => {
          if (child.isMesh) {
            // child.receiveShadow = true
            // child.castShadow = true
            // child.material.roughness = 0.8
            // child.material.metalness = 1.0
            // child.material.map.encoding = THREE.GammaEncoding
            // child.material.map.magFilter = THREE.LinearFilter
            // child.material.map.minFilter = THREE.LinearFilter
            // child.material.envMap = envMap
            // child.material.envMapIntensity = 2.0
            // child.material.needsUpdate = true
          }
        })
        // let modelData = zcfCommon.getModelDate(this.mesh, THREE)
        // zcfCommon.initCamera(this.camera, modelData, this.controls)
        this.mesh.scale.set(100,100,100)
        this.mesh.position.y=-7
        this.hasLoaded = true
        this.animate()
      })
      window.addEventListener('resize', this.onresize, false)
    },
    // 窗口改变
    onresize () {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
    },
    // 循环渲染
    render() {
      this.renderer.render(this.scene, this.camera)
    },
    animate () {
      this.rafId = requestAnimationFrame(this.animate)
      this.controls.update()
      TWEEN.update()
      this.render()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onresize, false)
    cancelAnimationFrame(this.rafId)
    this.renderer.dispose()
    this.renderer.forceContextLoss()
    // this.renderer.context = null
    this.renderer.domElement = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.rafId = null
    this.container = null
    this.mesh = null
    this.controls = null
    this.modelInfo = null
  }
};
</script>
